import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { get } from 'lodash-es';

import { applyTemplateParams } from 'site-modules/shared/components/lead-form/utils/utils';
import { LeadFormMarkdownView } from 'site-modules/shared/components/lead-form/lead-form-markdown-view/lead-form-markdown-view';
import { EdmundsLogo } from 'site-modules/shared/components/edmunds-logo/edmunds-logo';
import { Link } from 'site-modules/shared/components/link/link';
import { HeaderConfigPropTypes } from 'site-modules/shared/components/lead-form/lead-form-prop-types/lead-form-prop-types';

export function EmbeddedHeaderUI({
  config: { showLogo, srpLink, text, explainingText, className, tag: Tag } = {},
  templateParams = [],
  isMobile = false,
}) {
  return (
    <div className="embedded-form-header mb-1_5 mt-md-1_5">
      <Tag
        className={classNames('header-text mb-0_75 d-flex', className, {
          'flex-column': isMobile,
          'heading-3 text-primary': !className,
        })}
      >
        {showLogo && <EdmundsLogo inline className="me-md-0_5 mb-1 mb-md-0 align-self-md-baseline" />}
        {applyTemplateParams(templateParams, text)}
        {!!get(srpLink, 'to') && !isMobile && (
          <Link
            to={srpLink.to}
            className="btn btn-outline-primary-b size-14 btn-sm ms-auto"
            data-tracking-id="view_search_result"
            rel="nofollow"
          >
            {srpLink.text}
          </Link>
        )}
      </Tag>
      {explainingText && (
        <div className="mt-0_5 text-gray-darker">
          <LeadFormMarkdownView markdown={explainingText} templateParams={templateParams} />
        </div>
      )}
    </div>
  );
}

EmbeddedHeaderUI.propTypes = {
  config: HeaderConfigPropTypes.header,
  templateParams: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ), // dynamic object
  isMobile: PropTypes.bool,
};

export const mapStateToProps = ({ mobile }) => ({
  isMobile: mobile,
});

export const EmbeddedHeader = connect(mapStateToProps)(EmbeddedHeaderUI);
